import React from 'react';

import { Block } from '../common/Block.jsx';
import { EmptyPlaceholder } from '../layout/Builder.jsx';
import { default as _Image, ImageSrcSet, withHoverEffects } from '../common/Image.jsx';
import { default as InventoryHelper } from '../common/Inventory.jsx';
import { default as Layout } from '../common/Layout.jsx';
import Name from '../common/Name.jsx';
import { SliderCellContainer } from './SliderCell.jsx';
import Token from '../common/Token.jsx';
import Url from '../common/Url.jsx';
import Utilities from '../common/Utilities.jsx';

function RecentlyViewedCellContainer(props) {
    let pageProps;
    if (props.onPageProps) {
        pageProps = props.onPageProps();
    } else {
        pageProps = props.contentConfig;
    }
    const backgroundColor = Layout.backgroundColorV2(props, pageProps);
    const handleBlockProps = (d) => {
        if (!d.type) {
            return;
        }
        switch (d.type.value) {
            case Name.Block.Inventory.RecentlyViewed.Cell.Image:
                return { backgroundColor };
        }
    }
    let className = 'carousel__slide--recently__viewed';
    if (props.pageContext) {
        className += ` context--${props.pageContext}`
    }
    return (
        <SliderCellContainer
            {...props}
            backgroundColor={backgroundColor}
            blockPropsHandler={handleBlockProps}
            builder={props.builder || props.disabled}
            className={className}
            imageComponentName={Name.Block.Inventory.RecentlyViewed.Cell.Image}
            style={{ backgroundColor }}
            type="recentlyViewed" />
    );
}

// region IMAGE

function _RecentlyViewedImageComponent(props) {
    let inventory = props.data || {};
    if (inventory.inventory) {
        inventory = inventory.inventory;
    }
    let _image = {};
    if (inventory.images && inventory.images.length > 0) {
        _image = inventory.images[0];
    }
    let imageData = {};
    if (inventory.seo) {
        imageData = {
            alt: inventory.seo.imageAlt,
            caption: inventory.seo.imageCaption,
            description: inventory.seo.imageDescription,
            title: inventory.seo.imageTitle
        };
    }
    const backgroundColor = (Utilities.rgbaToHex(props.backgroundColor).hex || '').replace('#', '');
    const style = { display: 'block', fontSize: 0, lineHeight: 1, textAlign: 'center', width: '100%' };
    const [imageTuples, setImageTuples] = React.useState(undefined);
    const generateImageTuples = () => {
        const tuples = _Image.sizes.map(function (d) {
            let url;
            if (props.blockConfig && props.blockConfig.layout && props.blockConfig.layout.isCropped == true) {
                url = _Image.url(_image, d, d, 'c_fill');
            } else {
                url = _Image.url(
                    _image,
                    d,
                    d,
                    'c_pad',
                    undefined,
                    backgroundColor
                );
            }
            return { size: d, url: url };
        });
        setImageTuples(tuples);
    }
    React.useEffect(() => {
        generateImageTuples();
    }, []);
    React.useEffect(() => {
        generateImageTuples();
    }, [props.blockConfig.layout.isCropped, props.backgroundColor, _image.id]);

    let height;
    if (props.blockConfig && props.blockConfig.layout) {
        Block.mapStyleConfigProps(style, props.blockConfig.layout, (propName, propValue, propUnit) => {
            switch (propName) {
                case 'height':
                    if (propValue && propValue.length > 0) {
                        height = `${propValue}${propUnit}`;
                    }
                    return true;
                case 'hoverColor':
                case 'hoverEffect':
                case 'hoverScale':
                case 'hoverZoom':
                case 'isCropped':
                    return true;
            }
        });
    }
    let imageStyle = { height, margin: '0 auto' };
    Utilities.copyObject(props.hoverImageStyle, imageStyle);
    let image = (
        <ImageSrcSet
            builder={props.builder}
            config={props.config}
            data={imageData}
            imageId={`${props.blockId}-${_image.id}`}
            imageTuples={imageTuples}
            style={imageStyle} />
    )
    if (!props.builder && props.hoverEffectVisible) {
        image = <span style={props.hoverStyle} onMouseEnter={props.onHoverStart} onMouseLeave={props.onHoverEnd}>{image}{props.hoverEffect}</span>
    }
    const link = Url.getLink('', `art/${inventory.inventoryId}`, { sub: props.querySub, layout: props.queryLayout, dataSub: props.queryDataSub }, props.builder);
    return <a href={link} style={style}>{image}</a>
}
const RecentlyViewedImageComponent = withHoverEffects(_RecentlyViewedImageComponent, 'layout');
const Image = { Component: RecentlyViewedImageComponent };

// region META

function _RecentlyViewedMetaComponent(props) {
    let style = {};
    if (props.blockConfig && props.blockConfig.block) {
        Block.mapStyleConfigProps(style, props.blockConfig.block, (propName) => { return propName == 'design'; });
    }
    const layoutStyles = Block.mapLayoutStyleConfigPropsWithPageKit(style, props, { alignment: 'textAlign' });
    let className = 'cont--inventory__meta';
    if (!props.inLayout) {
        className += ' cont--kit__content';
    }
    let renderedContent = (
        <div className={className} style={layoutStyles.style}>
            {
                props.content != undefined &&
                <div className="cont--token" dangerouslySetInnerHTML={{ __html: props.content }} style={{ lineHeight: 1 }} />
            }
            {
                props.builder &&
                (props.content == undefined || props.content.length == 0) &&
                <EmptyPlaceholder />
            }
        </div>
    );
    if (layoutStyles.containerStyle) {
        renderedContent = <div className="cont--kit__wrapper" style={layoutStyles.containerStyle}>{renderedContent}</div>
    }
    return renderedContent;
}
const RecentlyViewedMetaComponent = Token.withContentTokenParsing(
    _RecentlyViewedMetaComponent,
    {
        extraParseConditionHandler: (props) => {
            let inventory = props.data || {};
            if (inventory.inventory) {
                inventory = inventory.inventory;
            }
            const edition = InventoryHelper.edition(inventory) || {};
            return [edition.editionId];
        }
    },
    (props, keyword, options) => {
        let inventory = props.data || {};
        if (inventory.inventory) {
            inventory = inventory.inventory;
        }
        const edition = InventoryHelper.edition(inventory) || {};
        const isArtist = props.config && props.config.userType == 1;
        let replaceString = Token.parsing.inventory({ edition, inventory, isArtist: isArtist, wrapContent: false }, keyword, options)
        if (!replaceString) {
            return replaceString;
        }
        switch (keyword) {
            case Token.ArtistName:
                replaceString = `<a alt="${inventory.artist.name}" href=${Url.getLink('', `artist/${inventory.artist.artistId}`, { sub: props.querySub, layout: props.queryLayout, dataSub: props.queryDataSub }, props.builder)}>${replaceString}</a>`
                break;
            case Token.Title:
                replaceString = `<a alt="${inventory.title}" href=${Url.getLink('', `art/${inventory.inventoryId}`, { sub: props.querySub, layout: props.queryLayout, dataSub: props.queryDataSub }, props.builder)}>${replaceString}</a>`
                break;
        }
        return replaceString;
    }
);
const RecentlyViewedMetaTokens = () => {
    return [
        Token.getWrappedTokenConfig('Artist Name', Token.ArtistName),
        Token.getWrappedTokenConfig('Title', Token.Title),
        Token.getWrappedTokenConfig('Edition Info', Token.Edition),
        Token.getWrappedTokenConfig('Created Date', Token.Date),
        Token.getWrappedTokenConfig('Medium', Token.Medium),
        Token.getWrappedTokenConfig('Dimensions', Token.Dimensions),
        Token.getWrappedTokenConfig('Alternate Dimensions', Token.AlternateDimensions),
        Token.getPriceTokenConfig()
    ];
}
const Meta = { Component: RecentlyViewedMetaComponent, Tokens: RecentlyViewedMetaTokens };

export { RecentlyViewedCellContainer, Image, Meta };